import { render, staticRenderFns } from "./imgD.vue?vue&type=template&id=3671b40b"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3671b40b')) {
      api.createRecord('3671b40b', component.options)
    } else {
      api.reload('3671b40b', component.options)
    }
    module.hot.accept("./imgD.vue?vue&type=template&id=3671b40b", function () {
      api.rerender('3671b40b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgD.vue"
export default component.exports